// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.doctorPageContainer {

    height: 100vh;
    padding-top: 100px;
    padding-right: 5%;

    background-color: #f1f7ff;
}


.moveQueue {
    border-radius: 10px;
    width: 150px;
    height: 50px;
    margin: 10px;

    font-weight: 600;
    font-size: 11pt;
    background-color: #e8f1ff;

}

.moveCont {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: row-reverse;
}

.moveQueue:hover {
    background-color: #c9d0ff;
    cursor: pointer;
}

.queuesList {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    justify-content: center;
    width: 80%;

}

.roomTitle {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: row-reverse;
    margin-bottom: 20px;
    font-size: 17pt;
    font-weight: 700;


}

.roomNumberTitle {
    font-size: 17pt;
    font-weight: 700;
    color: white;
    background-color: #1f60d4;
    padding: 1px 20px;
    border-radius: 100px;
    margin-right: 10px;


}

.queuesCont {
    background-color: rgb(255, 255, 255);
    border-radius: 20px;
    margin: 20px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 60%;
    padding: 20px;

}


.allBtnsCont {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column-reverse;
}

.queueDetails {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
}

.ApproveNextPatient {
    background-color: white;
    border-radius: 20px;
    padding: 10px;
    border: none;
    width: 40%;
    margin: 10px;
    color: rgb(173, 11, 11);
    font-weight: 700;
    font-size: 14pt;
}


.ApproveNextPatient:hover {
    color: rgb(245, 21, 21);
    background-color: rgb(255, 232, 232);


}

.currentPatient {
    background-image: linear-gradient(to right, #36D1DC 0%, #142ad0 51%, #36D1DC 100%);
    text-align: center;
    text-transform: uppercase;
    transition: 0.5s;
    background-size: 200% auto;
    box-shadow: 0 0 20px #eee;
    color: white;
    font-weight: 600;
    font-size: 20pt;
    padding: 30px;
    width: 50%;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;

}

.nextPatient {
    font-size: 10pt;
    background-color: #e4f3ff;
    padding: 10px 30px 10px 30px;
    width: 50%;
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;

}



.patientNumber {
    font-weight: 700;
    font-size: 40pt;
}

.queueDetTitle {
    font-weight: 700;
}


.queueIcon {
    color: rgb(94, 70, 255);

}

button {
    border: none;
    outline: none;
}



.anotherBtnsCont {
    display: flex;

}


.receptionRoomCont {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;

}

.secondCont {
    display: flex;
    justify-content: center;
    flex-direction: column;
}

.qeueuCenter {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    margin-bottom: 30px;

}

.anotherButtons {
    box-shadow: -3px 2px 0px 0px #e85656;
    width: 50px;
    height: 50px;
    border-radius: 12px;
    background-color: rgb(255 245 245);
    border: none;
    font-weight: 600;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition-duration: 0.3s;
    overflow: hidden;
    position: relative;
    margin: 10px;
    color: red;
}

.svgIcon {
    width: 12px;
    transition-duration: 0.3s;
}

.svgIcon path {
    fill: rgb(255, 16, 16);
}

.anotherButtons:hover {
    width: 140px;
    border-radius: 12px;
    transition-duration: 0.3s;
    background-color: rgb(255, 0, 0);
    align-items: center;
    color: white;
    box-shadow: none;

}

.anotherButtons:hover .svgIcon {
    /* width: 20px; */
    transition-duration: 0.3s;
    transform: translateY(-200%);
}

.EndOfTreatment::before {
    position: absolute;
    bottom: -20px;
    content: "סיום טיפול";
    color: white;
    font-size: 0px;
}

.emergencyAlert::before {
    position: absolute;
    bottom: -20px;
    content: "התראת חירום לרופא";
    color: white;
    font-size: 0px;
}

.anotherButtons:hover::before {
    font-size: 13px;
    opacity: 1;
    bottom: unset;
    transition-duration: 0.3s;
}

.callToPatient {
    padding: 15px;
    border-radius: 20px;
    margin: 20px;
    width: -moz-fit-content;
    width: fit-content;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column-reverse;
    background-color: #e8f1ff;

}

.numOfWaitPatientsRooms {
    background-image: linear-gradient(to right, #4ca0f9 0%, #3762f0 51%, #368cdc 100%);
    background-size: 200% auto;
    border-radius: 100px;
    color: white;
    width: 50px;
    margin-right: 10px;
    padding: 2px;
    font-weight: 600;

}

.numOfWaitPatientsContainerRooms {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    margin: 10px;
    font-size: 10pt;
}`, "",{"version":3,"sources":["webpack://./src/components/DoctorPage/DoctorPage.css"],"names":[],"mappings":"AAAA;;IAEI,aAAa;IACb,kBAAkB;IAClB,iBAAiB;;IAEjB,yBAAyB;AAC7B;;;AAGA;IACI,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,YAAY;;IAEZ,gBAAgB;IAChB,eAAe;IACf,yBAAyB;;AAE7B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,2BAA2B;AAC/B;;AAEA;IACI,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,uBAAuB;IACvB,UAAU;;AAEd;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,2BAA2B;IAC3B,mBAAmB;IACnB,eAAe;IACf,gBAAgB;;;AAGpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,yBAAyB;IACzB,iBAAiB;IACjB,oBAAoB;IACpB,kBAAkB;;;AAGtB;;AAEA;IACI,oCAAoC;IACpC,mBAAmB;IACnB,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,UAAU;IACV,aAAa;;AAEjB;;;AAGA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;AACf;;AAEA;IACI,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,YAAY;IACZ,UAAU;IACV,YAAY;IACZ,uBAAuB;IACvB,gBAAgB;IAChB,eAAe;AACnB;;;AAGA;IACI,uBAAuB;IACvB,oCAAoC;;;AAGxC;;AAEA;IACI,kFAAkF;IAClF,kBAAkB;IAClB,yBAAyB;IACzB,gBAAgB;IAChB,0BAA0B;IAC1B,yBAAyB;IACzB,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,aAAa;IACb,UAAU;IACV,4BAA4B;IAC5B,6BAA6B;;AAEjC;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,4BAA4B;IAC5B,UAAU;IACV,+BAA+B;IAC/B,gCAAgC;;AAEpC;;;;AAIA;IACI,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;;;AAGA;IACI,uBAAuB;;AAE3B;;AAEA;IACI,YAAY;IACZ,aAAa;AACjB;;;;AAIA;IACI,aAAa;;AAEjB;;;AAGA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,uBAAuB;;AAE3B;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,sBAAsB;IACtB,mBAAmB;;AAEvB;;AAEA;IACI,oCAAoC;IACpC,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,kCAAkC;IAClC,YAAY;IACZ,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,yBAAyB;IACzB,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;IACZ,UAAU;AACd;;AAEA;IACI,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,yBAAyB;IACzB,gCAAgC;IAChC,mBAAmB;IACnB,YAAY;IACZ,gBAAgB;;AAEpB;;AAEA;IACI,iBAAiB;IACjB,yBAAyB;IACzB,4BAA4B;AAChC;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,qBAAqB;IACrB,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,4BAA4B;IAC5B,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,UAAU;IACV,aAAa;IACb,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,uBAAkB;IAAlB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,8BAA8B;IAC9B,yBAAyB;;AAE7B;;AAEA;IACI,kFAAkF;IAClF,0BAA0B;IAC1B,oBAAoB;IACpB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;;AAEpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,eAAe;AACnB","sourcesContent":[".doctorPageContainer {\r\n\r\n    height: 100vh;\r\n    padding-top: 100px;\r\n    padding-right: 5%;\r\n\r\n    background-color: #f1f7ff;\r\n}\r\n\r\n\r\n.moveQueue {\r\n    border-radius: 10px;\r\n    width: 150px;\r\n    height: 50px;\r\n    margin: 10px;\r\n\r\n    font-weight: 600;\r\n    font-size: 11pt;\r\n    background-color: #e8f1ff;\r\n\r\n}\r\n\r\n.moveCont {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    flex-direction: row-reverse;\r\n}\r\n\r\n.moveQueue:hover {\r\n    background-color: #c9d0ff;\r\n    cursor: pointer;\r\n}\r\n\r\n.queuesList {\r\n    display: flex;\r\n    align-items: center;\r\n    flex-wrap: wrap;\r\n    justify-content: center;\r\n    width: 80%;\r\n\r\n}\r\n\r\n.roomTitle {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    flex-direction: row-reverse;\r\n    margin-bottom: 20px;\r\n    font-size: 17pt;\r\n    font-weight: 700;\r\n\r\n\r\n}\r\n\r\n.roomNumberTitle {\r\n    font-size: 17pt;\r\n    font-weight: 700;\r\n    color: white;\r\n    background-color: #1f60d4;\r\n    padding: 1px 20px;\r\n    border-radius: 100px;\r\n    margin-right: 10px;\r\n\r\n\r\n}\r\n\r\n.queuesCont {\r\n    background-color: rgb(255, 255, 255);\r\n    border-radius: 20px;\r\n    margin: 20px;\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: center;\r\n    width: 60%;\r\n    padding: 20px;\r\n\r\n}\r\n\r\n\r\n.allBtnsCont {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    flex-direction: column-reverse;\r\n}\r\n\r\n.queueDetails {\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    justify-content: center;\r\n    width: 100%;\r\n}\r\n\r\n.ApproveNextPatient {\r\n    background-color: white;\r\n    border-radius: 20px;\r\n    padding: 10px;\r\n    border: none;\r\n    width: 40%;\r\n    margin: 10px;\r\n    color: rgb(173, 11, 11);\r\n    font-weight: 700;\r\n    font-size: 14pt;\r\n}\r\n\r\n\r\n.ApproveNextPatient:hover {\r\n    color: rgb(245, 21, 21);\r\n    background-color: rgb(255, 232, 232);\r\n\r\n\r\n}\r\n\r\n.currentPatient {\r\n    background-image: linear-gradient(to right, #36D1DC 0%, #142ad0 51%, #36D1DC 100%);\r\n    text-align: center;\r\n    text-transform: uppercase;\r\n    transition: 0.5s;\r\n    background-size: 200% auto;\r\n    box-shadow: 0 0 20px #eee;\r\n    color: white;\r\n    font-weight: 600;\r\n    font-size: 20pt;\r\n    padding: 30px;\r\n    width: 50%;\r\n    border-top-left-radius: 10px;\r\n    border-top-right-radius: 10px;\r\n\r\n}\r\n\r\n.nextPatient {\r\n    font-size: 10pt;\r\n    background-color: #e4f3ff;\r\n    padding: 10px 30px 10px 30px;\r\n    width: 50%;\r\n    border-bottom-left-radius: 10px;\r\n    border-bottom-right-radius: 10px;\r\n\r\n}\r\n\r\n\r\n\r\n.patientNumber {\r\n    font-weight: 700;\r\n    font-size: 40pt;\r\n}\r\n\r\n.queueDetTitle {\r\n    font-weight: 700;\r\n}\r\n\r\n\r\n.queueIcon {\r\n    color: rgb(94, 70, 255);\r\n\r\n}\r\n\r\nbutton {\r\n    border: none;\r\n    outline: none;\r\n}\r\n\r\n\r\n\r\n.anotherBtnsCont {\r\n    display: flex;\r\n\r\n}\r\n\r\n\r\n.receptionRoomCont {\r\n    display: flex;\r\n    flex-direction: row;\r\n    align-items: center;\r\n    justify-content: center;\r\n\r\n}\r\n\r\n.secondCont {\r\n    display: flex;\r\n    justify-content: center;\r\n    flex-direction: column;\r\n}\r\n\r\n.qeueuCenter {\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    flex-direction: column;\r\n    margin-bottom: 30px;\r\n\r\n}\r\n\r\n.anotherButtons {\r\n    box-shadow: -3px 2px 0px 0px #e85656;\r\n    width: 50px;\r\n    height: 50px;\r\n    border-radius: 12px;\r\n    background-color: rgb(255 245 245);\r\n    border: none;\r\n    font-weight: 600;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    cursor: pointer;\r\n    transition-duration: 0.3s;\r\n    overflow: hidden;\r\n    position: relative;\r\n    margin: 10px;\r\n    color: red;\r\n}\r\n\r\n.svgIcon {\r\n    width: 12px;\r\n    transition-duration: 0.3s;\r\n}\r\n\r\n.svgIcon path {\r\n    fill: rgb(255, 16, 16);\r\n}\r\n\r\n.anotherButtons:hover {\r\n    width: 140px;\r\n    border-radius: 12px;\r\n    transition-duration: 0.3s;\r\n    background-color: rgb(255, 0, 0);\r\n    align-items: center;\r\n    color: white;\r\n    box-shadow: none;\r\n\r\n}\r\n\r\n.anotherButtons:hover .svgIcon {\r\n    /* width: 20px; */\r\n    transition-duration: 0.3s;\r\n    transform: translateY(-200%);\r\n}\r\n\r\n.EndOfTreatment::before {\r\n    position: absolute;\r\n    bottom: -20px;\r\n    content: \"סיום טיפול\";\r\n    color: white;\r\n    font-size: 0px;\r\n}\r\n\r\n.emergencyAlert::before {\r\n    position: absolute;\r\n    bottom: -20px;\r\n    content: \"התראת חירום לרופא\";\r\n    color: white;\r\n    font-size: 0px;\r\n}\r\n\r\n.anotherButtons:hover::before {\r\n    font-size: 13px;\r\n    opacity: 1;\r\n    bottom: unset;\r\n    transition-duration: 0.3s;\r\n}\r\n\r\n.callToPatient {\r\n    padding: 15px;\r\n    border-radius: 20px;\r\n    margin: 20px;\r\n    width: fit-content;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    flex-direction: column-reverse;\r\n    background-color: #e8f1ff;\r\n\r\n}\r\n\r\n.numOfWaitPatientsRooms {\r\n    background-image: linear-gradient(to right, #4ca0f9 0%, #3762f0 51%, #368cdc 100%);\r\n    background-size: 200% auto;\r\n    border-radius: 100px;\r\n    color: white;\r\n    width: 50px;\r\n    margin-right: 10px;\r\n    padding: 2px;\r\n    font-weight: 600;\r\n\r\n}\r\n\r\n.numOfWaitPatientsContainerRooms {\r\n    display: flex;\r\n    flex-direction: row;\r\n    align-items: center;\r\n    justify-content: center;\r\n    margin: 10px;\r\n    font-size: 10pt;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
